module.exports = new __parcel__URL__("lune-nuage-2-pluie-3.e99f3c7e.svg").toString();